import React, { useEffect, useState } from 'react';

import {
    Box,
} from '@mui/joy';
import ButtonAttribute from '../../Components/ButtonAttribute';
import { faDownload, faCheck, faCloudArrowUp, faFileExport, faFileImport, faPen, faPlus, faTrash, faTableList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataGridTable from '../../Components/TableData';
import { Checkbox, createTheme, Divider, Grid, ThemeProvider, Typography } from '@mui/material';
import BasicModal from '../../Components/BasicModel';
import axios from 'axios';
import { API } from '../../API/api';
import TextInputMui from '../../Components/TextInputMui';
import AlertBar from '../../Components/AlertBar';
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';
import CustomizedProgressBars from '../../Components/CustomizedProgressBars';
import AutocompleteComboBox from '../../Components/AutocompleteComboBox';
import DateTimePickerComponent from '../../Components/DateTimePicker';
import { logOperation } from "../../API/logOperation"; // adjust path
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
const theme = createTheme({
    typography: {
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        h4: {
            fontWeight: 700,
            letterSpacing: '-0.025em'
        },
        h6: {
            fontWeight: 600,
            letterSpacing: '-0.025em'
        },
        body1: {
            fontWeight: 500
        }
    },
    palette: {
        mode: 'light',
        primary: {
            main: '#3b82f6',
            light: '#8b9eff',
            dark: '#2563eb'
        },
        secondary: {
            main: '#8b5cf6',
            light: '#a78bfa',
            dark: '#7c3aed'
        },
        background: {
            default: '#f8fafc',
            paper: '#ffffff'
        },
        text: {
            primary: '#1f2937',
            secondary: '#6b7280'
        }
    },
    shape: {
        borderRadius: 8
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: 8,
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                    }
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                }
            }
        }
    }
});



export default function Clients() {
    const [ImportData, setImportData] = useState();
    const [isLoading, setIsLoading] = useState(0);
    const [importStatus, setImportStatus] = useState("idle");
    // idle | processing | success | error
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [Clients, setClients] = useState([]);
    const [openAjouterClient, setOpenAjouterClient] = React.useState(false);
    const [rowsSelected, setRowsSelected] = React.useState({});
    const handleOpen = () => setOpenAjouterClient(true);
    const handleClose = () => setOpenAjouterClient(false);
    const [Permissions, setPermissions] = useState([]);
    const [role, setRole] = useState([]);
    const [typeClients, setTypeClients] = useState([
        { label: 'Entreprise', value: 'Entreprise' },
        { label: 'Particulier', value: 'Particulier' },
        { label: 'Autre', value: 'Autre' },
    ]);


    useEffect(() => {
        const storedAuthState = sessionStorage.getItem('authLocalstorage');
        const parsedAuthState = JSON.parse(storedAuthState);
        localStorage.removeItem('selectedRows');

        if (parsedAuthState?.token) {
            setPermissions(parsedAuthState.permissions);
            setRole(parsedAuthState.user.role.name);
            fetchClients(parsedAuthState.token);
            const intervalId = setInterval(() => {
                setErrors({ error: false, message: '' });
            }, 10000);

            // Cleanup interval on component unmount
            return () => clearInterval(intervalId);
        } else {
            console.error('Token does not exist');
        }
    }, []);
    {/* modifier Client */ }
    const [openModifierClient, setOpenModifierClient] = React.useState(false);
    const handleOpenModifier = () => {
        const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);
        if (selectedRows.length > 0) {
            setOpenModifierClient(true);
            setRowsSelected(selectedRows);
            setModifierClient(selectedRows[0]);
        }
        else {
            setAlertOpenSelectedModifier(true);
        }
    }
    const handleCloseModifier = () => {
        setOpenModifierClient(false);
    }

    const [alertOpenSelectedModifier, setAlertOpenSelectedModifier] = useState(false);
    const handleAlertCloseSelectedModifier = () => { setAlertOpenSelectedModifier(false); }
    const [alertOpenNotModiferRow, setAlertOpenNotModiferRow] = useState(false);
    const handleAlertCloseNotModiferRow = () => { setAlertOpenNotModiferRow(false); }
    const handleAlertOpenNotModiferRow = () => { setAlertOpenNotModiferRow(true); }
    const [alertOpenUpdatedClient, setAlertOpenUpdatedClient] = useState(false);
    const handleAlertCloseUpdatedClient = () => { setAlertOpenUpdatedClient(false); }
    const handleAlertOpenUpdatedClient = () => { setAlertOpenUpdatedClient(true); }

    const handleOpenModifierOneClient = async () => {
        const clientOrig = rowsSelected[0];

        const isIdentique = Object.keys(modifierClient).every((key) => {
            return clientOrig[key] === modifierClient[key];
        });

        if (isIdentique) {
            handleAlertOpenNotModiferRow();
            return;
        }

        const requiredFields = [
            { key: 'Nom', label: 'Nom' },
            { key: 'Email', label: 'Email' },
            { key: 'Contact', label: 'Contact' },
            { key: 'Type_Client', label: 'Type de client' },
            { key: 'Code_client', label: 'Code client' }
        ];

        const champsManquants = requiredFields
            .filter(({ key }) => !modifierClient[key] || modifierClient[key].toString().trim() === "")
            .map(({ label }) => label);

        if (champsManquants.length > 0) {
            setErrors({
                error: true,
                message: "Champs obligatoires manquants : " + champsManquants.join(", "),
            });
            return;
        }

        try {
            const storedAuthState = sessionStorage.getItem('authLocalstorage');
            const parsedAuthState = JSON.parse(storedAuthState);
            const ID = modifierClient.ID_Client;

            const response = await axios.put(
                `${API}/clients/${ID}`,
                modifierClient,
                {
                    headers: { Authorization: `Bearer ${parsedAuthState.token}` },
                }
            );

            handleAlertOpenUpdatedClient();
            handleCloseModifier();
            fetchClients(parsedAuthState.token);

            logOperation({
                operation_type: "UPDATE",
                entity_type: "Client",
                entity_id: parsedAuthState.user.id,
                description: "Modification des informations du client",
            });

        } catch (error) {
            if (error.response) {
                console.error('Erreur de réponse API:', error.response.data);
                setErrors({
                    error: true,
                    message: "Une erreur de réponse API est survenue lors de la modification du client.",
                });
            } else if (error.request) {
                setErrors({
                    error: true,
                    message: "Une erreur s'est produite lors de la modification du client.",
                });
            } else {
                console.error('Erreur inconnue:', error.message);
                setErrors({
                    error: true,
                    message: "Une erreur s'est produite lors de la modification du client.",
                });
            }
        }
    };

    {/* end modifier Client */ }

    const [errors, setErrors] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);

    const handleAlertClose = () => { setAlertOpen(false); };
    const [newClient, setNewClient] = useState({
        Nom: '',
        Adresse: '',
        Email: '',
        Contact: '',
        Type_Client: '',
        Raison_sociale: '',     // Added Raison_sociale
        Forme_juridique: '',    // Added Forme_juridique
        Code_client: '',        // Added Code_client
        Sites: '',              // Added Sites
        IF: '',                 // Added IF
        ICE: '',                // Added ICE
        taux_de_TVA: '',        // Added taux_de_TVA
        taux_de_TVA_1: '',      // Added taux_de_TVA 1
        Mode_de_reglement: '',  // Added Mode_de_reglement
        Echéance_de_reglement: '',  // Added Echéance_de_reglement
        Activité: '',           // Added Activité
    });
    const [modifierClient, setModifierClient] = useState({
        Nom: '',
        Adresse: '',
        Email: '',
        Contact: '',
        Type_Client: '',
        Raison_sociale: '',     // Added Raison_sociale
        Forme_juridique: '',    // Added Forme_juridique
        Code_client: '',        // Added Code_client
        Sites: '',              // Added Sites
        IF: '',                 // Added IF
        ICE: '',                // Added ICE
        taux_de_TVA: '',
        taux_de_TVA_1: '',       // Added taux_de_TVA 1
        Mode_de_reglement: '',  // Added Mode_de_reglement
        Echéance_de_reglement: '',  // Added Echéance_de_reglement
        Activité: '',
    });


    {/* Delete Client */ }
    const [alertOpenDeletedClient, setAlertOpenDeletedClient] = useState(false);
    const handleAlertCloseDeletedClient = () => { setAlertOpenDeletedClient(false); }
    const handleAlertOpenDeletedClient = () => { setAlertOpenDeletedClient(true); }
    const [alertOpenMultiDeletedClient, setAlertMultiOpenDeletedClient] = useState(false);
    const handleAlertMultiCloseDeletedClient = () => { setAlertMultiOpenDeletedClient(false); }
    const handleAlertMultiOpenDeletedClient = () => { setAlertMultiOpenDeletedClient(true); }
    const [openDeleteClient, setOpenDeleteClient] = useState(false);
    const [alertOpenPasswordNotValid, setAlertOpenPasswordNotValid] = useState(false);
    const handleAlertClosePasswordNotValid = () => { setAlertOpenPasswordNotValid(false); }
    const handleAlertOpenPasswordNotValid = () => { setAlertOpenPasswordNotValid(true); }
    const handleOpenDeleteClient = () => {
        const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);
        if (selectedRows.length > 0) {
            setOpenDeleteClient(true);
            setRowsSelected(selectedRows);
            setModifierClient(selectedRows[0]);
        }
        else {
            setAlertOpenSelectedModifier(true);
        }

    }
    const handleCloseDeleteClient = () => { setOpenDeleteClient(false); }
    const handleDeleteClient = async () => {
        const storedAuthState = sessionStorage.getItem('authLocalstorage');
        const parsedAuthState = JSON.parse(storedAuthState);
        const ID = modifierClient.ID_Client;

        try {
            // Make the DELETE request
            const response = await axios.delete(`${API}/clients/${ID}`, {
                headers: { Authorization: `Bearer ${parsedAuthState.token}` }
            });
            // Handle the response
            handleCloseDeleteClient();
            setAlertOpenDeletedClient(true);
            logOperation({
                operation_type: "DELETE",
                entity_type: "Client",
                entity_id: parsedAuthState.user.id,
                description: "Delete des informations du client",
            });
        }
        catch (error) {
            // Handle errors
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                console.error('Error Response:', error.response.data.error);
            } else if (error.request) {
                // The request was made but no response was received
                console.error('Error Request:', error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error('Error Message:', error.message);
            }
        }



    }
    const handleDeleteMultiClients = async () => {
        const storedAuthState = sessionStorage.getItem('authLocalstorage');
        const parsedAuthState = JSON.parse(storedAuthState);

        //const ID = modifierClient.ID_Client;
        try {
            // Make the DELETE request
            const promises = rowsSelected.map((row) => {
                return axios.delete(`${API}/clients/${row.ID_Client}`, {
                    headers: { Authorization: `Bearer ${parsedAuthState.token}` }
                });
            });
            const responses = await Promise.all(promises); // Wait for all deletions to complete
            handleCloseDeleteClient();
            handleAlertMultiOpenDeletedClient();
            logOperation({
                operation_type: "DELETE MULTIPLE",
                entity_type: "Client",
                entity_id: parsedAuthState.user.id,
                description: "Delete des clients",
            });
        }
        catch (error) {
            // Handle errors
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                console.error('Error Response:', error.response.data.error);
            } else if (error.request) {
                // The request was made but no response was received
                console.error('Error Request:', error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error('Error Message:', error.message);
            }
        }
    }

    const handleVerificationPassword = () => {
        const storedAuthState = sessionStorage.getItem('authLocalstorage');
        const parsedAuthState = JSON.parse(storedAuthState);
        const email = parsedAuthState.user.email;
        const password = ConfrimedPassword.password;

        axios
            .post(`${API}/verify-password`, { email, password })
            .then((response) => {
                if (response.data.success) {
                    if (rowsSelected.length === 1) {
                        handleDeleteClient();
                    } else {
                        handleDeleteMultiClients();
                    }
                    handleCloseConfirmationPassword();
                    fetchClients(parsedAuthState.token);
                } else {
                    // Handle unexpected responses where success is false
                    setConfirmedPassword({
                        errors: true,
                    });
                    console.error("Password verification failed:", response.data);
                    handleAlertOpenPasswordNotValid();
                }
            })
            .catch((error) => {
                // Handle errors from the server or network issues
                if (error.response) {
                    // Server responded with a status other than 2xx
                    console.error("Error response:", error.response.data);
                    setConfirmedPassword({
                        errors: true,
                    });
                    handleAlertOpenPasswordNotValid();
                } else if (error.request) {
                    // Request was made but no response received
                    console.error("No response received:", error.request);
                } else {
                    // Something else happened
                    console.error("Error setting up request:", error.message);
                }
            });

    }


    {/* End Delete Client */ }

    {/* Begin interlocuteurs */ }
    const HandleCloseShowInterlocuteurs = () => { setOpenShowInterlocuteurs(false) };
    const [interlocuteurs, setInterlocuteurs] = useState([]);
    const [selectedClient, setSelectedClient] = useState({});
    const [newInterlocuteur, setNewInterlocuteur] = useState({
        Nom: '',
        Fonction: '',
        Email: '',
        Contact: '',
        ID_Client: selectedClient.ID_Client
    });

    const [errorsInterlocuteur, setErrorsInterlocuteur] = useState({
        errors: false,
        message: '',
    });

    const thStyle = {
        padding: '10px',
        textAlign: 'left',
        fontWeight: 'bold',
        fontSize: '14px',
        borderBottom: '1px solid #ccc',
    };

    const tdStyle = {
        padding: '10px',
        fontSize: '14px',
        borderBottom: '1px solid #eee',
    };
    const [openShowInterlocuteurs, setOpenShowInterlocuteurs] = useState(false);

    const [alertOpenAjouterInterlocuteur, setAlertOpenAjouterInterlocuteur] = useState(false);
    const handleOpenAjouterInterlocuteur = () => { setAlertOpenAjouterInterlocuteur(true); }
    const handleCloseAlertInterlocuteur = () => { setAlertOpenAjouterInterlocuteur(false); }

    const [alertOpenDeletedInterlocuteur, setAlertOpenDeletedInterlocuteur] = useState(false);
    const handleOpenDeletedInterlocuteur = () => { setAlertOpenDeletedInterlocuteur(true); }
    const handleCloseAlertDeletedInterlocuteur = () => { setAlertOpenDeletedInterlocuteur(false); }
    const HandleOpenShowInterlocuteurs = () => {

        const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);
        if (selectedRows.length > 0) {

            setRowsSelected(selectedRows);
            setModifierClient(selectedRows[0]);
            setSelectedClient(selectedRows[0]);
            fetchGetInterlocuteurs();
            setOpenShowInterlocuteurs(true);
        }
        else {
            setAlertOpenSelectedModifier(true);
        }
    };

    const fetchGetInterlocuteurs = () => {
        const storedAuthState = sessionStorage.getItem('authLocalstorage');
        const parsedAuthState = JSON.parse(storedAuthState);
        const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);
        setSelectedClient(selectedRows[0]);
        axios.get(`${API}/interlocuteurs/client/${selectedRows[0].ID_Client}`, {
            headers: { Authorization: `Bearer ${parsedAuthState.token}` }
        }).then((response) => {
            setInterlocuteurs(response.data);
        }).catch((error) => {
            console.error('Error fetching interlocuteurs:', error);
        });

    };
    const handleAddInterlocuteur = () => {

        const storedAuthState = sessionStorage.getItem('authLocalstorage');
        const parsedAuthState = JSON.parse(storedAuthState);
        const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);

        const idClient = selectedRows[0].ID_Client;

        const missingFields = [];

        if (!newInterlocuteur.Nom?.trim()) {
            missingFields.push("Nom");
        }

        if (!newInterlocuteur.Fonction?.trim()) {
            missingFields.push("Fonction");
        }

        if (!newInterlocuteur.Email?.trim()) {
            missingFields.push("Email");
        }

        if (!newInterlocuteur.Contact?.trim()) {
            missingFields.push("Contact");
        }

        if (missingFields.length > 0) {
            setErrorsInterlocuteur({
                errors: true,
                message: `Les champs suivants sont obligatoires : ${missingFields.join(", ")}`,
            });
            return;
        }
        else {


            axios.post(`${API}/interlocuteurs`,
                {
                    Nom: newInterlocuteur.Nom,
                    Fonction: newInterlocuteur.Fonction,
                    Email: newInterlocuteur.Email,
                    Contact: newInterlocuteur.Contact,
                    ID_Client: idClient
                }, {
                headers: { Authorization: `Bearer ${parsedAuthState.token}` }
            }).then((response) => {
                fetchGetInterlocuteurs(); // refresh table
                setNewInterlocuteur({ Nom: '', Fonction: '', Email: '', Contact: '', ID_Client: selectedClient.ID_Client });
                handleOpenAjouterInterlocuteur();
                setErrorsInterlocuteur({ errors: false, message: '' });
                // then log the operation
                logOperation({
                    operation_type: "CREATE",
                    entity_type: "Interlocuteur",
                    entity_id: parsedAuthState.user.id,
                    description: " Ajout d'un interlocuteur ",
                });

            }).catch((error) => {
                console.error('Error adding interlocuteur:', error);
                setErrorsInterlocuteur({ errors: true, message: "L'interlocuteur n'a pas pu être ajouté veuillez réessayer" });
            })
        }

    };

    const handleDeleteInterlocuteur = (id) => {
        const storedAuthState = sessionStorage.getItem('authLocalstorage');
        const parsedAuthState = JSON.parse(storedAuthState);
        axios.delete(`${API}/interlocuteurs/${id}`, {
            headers: { Authorization: `Bearer ${parsedAuthState.token}` }
        }).then((response) => {
            fetchGetInterlocuteurs(); // refresh table
            handleOpenDeletedInterlocuteur();
            logOperation({
                operation_type: "DELETE",
                entity_type: "Client",
                entity_id: parsedAuthState.user.id,
                description: "Delete des informations du client",
            });
        }).catch((error) => {
            console.error('Error deleting interlocuteur:', error);
        });
    };

    {/* end  interlocuteurs */ }

    {/* Begin Extration Client */ }
    const [openExtrationClient, setOpenExtrationClient] = useState(false);
    const handleCloseExtrationClient = () => { setOpenExtrationClient(false); }
    const handleOpenExtrationClient = () => { setOpenExtrationClient(true); }
    const [alertOpenNotSelectedLineExtration, setAlertOpenNotSelectedLineExtration] = useState(false);
    const handleAlertOpenNotSelectedLineExtration = () => { setAlertOpenNotSelectedLineExtration(true) };
    const handleAlertCloseNotSelectedLineExtration = () => { setAlertOpenNotSelectedLineExtration(false) };

    const handleExtrationAllClient = () => {
        const storedAuthState = sessionStorage.getItem('authLocalstorage');
        const parsedAuthState = JSON.parse(storedAuthState);

        // Génération des données pour Excel
        const exportData = Clients.map((client) => {
            const row = {};
            columns.forEach((col) => {
                row[col.header] = client[col.accessorKey] || '';  // Utilise les en-têtes lisibles
            });
            return row;
        });

        // Création d'une feuille de calcul
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Clients");

        // Générer un fichier blob Excel
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        // Télécharger le fichier
        saveAs(blob, "Clients.xlsx");

        // Log d'opération
        logOperation({
            operation_type: "Extraction",
            entity_type: "Client",
            entity_id: parsedAuthState.user.id,
            description: "Extraction des informations de tous les clients (XLSX)",
        });
    };

    const handleExtrationSelectionsClients = () => {
        const storedAuthState = sessionStorage.getItem('authLocalstorage');
        const parsedAuthState = JSON.parse(storedAuthState);

        const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);

        if (selectedRows && selectedRows.length > 0) {
            // Préparer les données à exporter
            const exportData = selectedRows.map((client) => {
                const row = {};
                columns.forEach((col) => {
                    row[col.header] = client[col.accessorKey] || ""; // Utilise les headers lisibles
                });
                return row;
            });

            // Création de la feuille Excel
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Clients sélectionnés");

            // Conversion en fichier Excel
            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            // Télécharger le fichier
            saveAs(blob, "Clients_selection.xlsx");

            // Journalisation de l'opération
            logOperation({
                operation_type: "Exportation",
                entity_type: "Client",
                entity_id: parsedAuthState.user.id,
                description: "Exportation des informations du client sélectionné",
            });

        } else {
            handleAlertOpenNotSelectedLineExtration();
        }
    };

    {/* End Extration Client */ }

    {/* Begin importation Client */ }
    const [openImportationClient, setOpenImportationClient] = useState(false);
    const handleCloseImportationClient = () => { setOpenImportationClient(false); }
    const handleOpenImportationClient = () => { setOpenImportationClient(true); }
    const [alertOpenImport, setAlertOpenImport] = useState(false);
    const handleAlertOpenImport = () => { setAlertOpenImport(true); }
    const handleCloseAlertImport = () => { setAlertOpenImport(false); }
    const [alertErrorImport, setAlertErrorImport] = useState(false);
    const handleOpenErrorAlertImport = () => { setAlertErrorImport(true); }
    const handleCloseErrorAlertImport = () => { setAlertErrorImport(false); }
    // Function to handle file download
    const handleDownload = () => {
        const filePath = `/ImportClients.xlsx`; // Adjust the path and filename as needed
        const link = document.createElement('a');
        link.href = filePath;
        link.download = 'ImportClients.xlsx'; // Name for the downloaded file
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const triggerFileInput = () => {
        document.getElementById("file-upload").click();
    };

    // Handle file import and parse the Excel file
   const handleFileImport = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  const storedAuthState = sessionStorage.getItem("authLocalstorage");
  const parsedAuthState = JSON.parse(storedAuthState);

  reader.onload = async (e) => {
    try {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

      if (!jsonData || jsonData.length === 0) {
        toast.error("Le fichier est vide.");
        return;
      }

      const requiredFields = [
        "Nom",
        "Code_client",
        "Contact",
        "Email",
        "Type_Client",
      ];

      /* ===============================
         CHECK REQUIRED COLUMNS
      =============================== */

      const fileColumns = Object.keys(jsonData[0]);

      const missingColumns = requiredFields.filter(
        (field) => !fileColumns.includes(field)
      );

      if (missingColumns.length > 0) {
        toast.error(
          `Colonnes manquantes : ${missingColumns.join(", ")}`
        );
        return;
      }

      /* ===============================
         CHECK REQUIRED FIELDS PER ROW
      =============================== */

      const validationErrors = [];

      jsonData.forEach((row, index) => {
        const missingFields = requiredFields.filter(
          (field) =>
            !row[field] || row[field].toString().trim() === ""
        );

        if (missingFields.length > 0) {
          validationErrors.push({
            row: index + 2,
            missingFields,
          });
        }
      });

      if (validationErrors.length > 0) {
        const message = validationErrors
          .map(
            (err) =>
              `Ligne ${err.row}: ${err.missingFields.join(", ")}`
          )
          .join(" | ");

        toast.error(
          `Import annulé. Erreurs détectées → ${message}`
        );
        return;
      }

      /* ===============================
         START INSERT
      =============================== */

      setIsLoading(0);
      setImportStatus("processing");

      let processedRows = 0;
      let successCount = 0;
      let failedCount = 0;
      const successLines = [];
      const failedLines = [];

      for (let i = 0; i < jsonData.length; i++) {
        const row = jsonData[i];

        try {
          await axios.post(
            `${API}/clients`,
            {
              Nom: row["Nom"],
              Adresse: row["Adresse"],
              Email: row["Email"],
              Contact: String(row["Contact"]),
              Type_Client: row["Type_Client"],
              Raison_sociale: row["Raison_sociale"],
              Forme_juridique: row["Forme_juridique"],
              Code_client: row["Code_client"],
              Sites: row["Sites"],
              IF: String(row["IF"]),
              ICE: String(row["ICE"]),
              taux_de_TVA: row["taux_de_TVA"],
              Mode_de_reglement: row["Mode_de_reglement"],
              Echéance_de_reglement:
                row["Echéance_de_reglement"],
              Activité: row["Activité"],
            },
            {
              headers: {
                Authorization: `Bearer ${parsedAuthState.token}`,
              },
            }
          );

          successCount++;
          successLines.push(i + 2);

        } catch (error) {
          failedCount++;
          failedLines.push(i + 2);
          console.error(`Erreur ligne ${i + 2}`, error);
        }

        processedRows++;
        setIsLoading(
          (processedRows / jsonData.length) * 100
        );
      }

      /* ===============================
         FINAL RESULT
      =============================== */

      if (failedCount > 0) {
        setImportStatus("error");

        toast.error(
          `Import terminé.
          
✅ Succès : ${successCount} ligne(s)
❌ Échec : ${failedCount} ligne(s)
          
Lignes insérées : ${successLines.join(", ") || "Aucune"}
Lignes échouées : ${failedLines.join(", ") || "Aucune"}`
        );
      } else {
        setImportStatus("success");

        toast.success(
          `Importation réussie !

${successCount} ligne(s) insérée(s).

Lignes : ${successLines.join(", ")}`
        );

        logOperation({
          operation_type: "Importation",
          entity_type: "Client",
          entity_id: parsedAuthState.user.id,
          description:
            "Importation des informations du client",
        });
      }

      fetchClients(parsedAuthState.token);

      setTimeout(() => {
        setIsLoading(0);
        setImportStatus("idle");
      }, 4000);

    } catch (error) {
      console.error("Erreur globale:", error);
      setImportStatus("error");
      toast.error("Erreur inattendue pendant l'import.");
      setIsLoading(0);
    }
  };

  reader.readAsBinaryString(file);
};


    {/* end importation Client */ }

    {/* Begin Confirm password for delete Client */ }

    const [openConfirmationPassword, setOpenConfirmationPassword] = useState(false);
    const handleCloseConfirmationPassword = () => { setOpenConfirmationPassword(false); }
    const handleOpenConfirmationPassword = () => { setOpenConfirmationPassword(true); }
    const [ConfrimedPassword, setConfirmedPassword] = useState({
        password: "",
        errors: "",
    });
    const [alertOpenConfirmDeleteClient, setAlertOpenConfirmDeleteClient] = useState(false);
    const handleAlertOpenConfirmDeleteClient = () => { setAlertOpenConfirmDeleteClient(true); }
    const handleCloseAlertConfirmDeleteClient = () => { setAlertOpenConfirmDeleteClient(false); }

    {/* End Confirm password for delete Client */ }

    const MenuButton = () => {
        return (
            <Box sx={{
                backgroundColor: '#ffffff',
                border: '1px solid #e5e7eb4b',
                borderRadius: '32px',
                padding: { xs: '20px', md: '30px' },
                marginBottom: '20px',
                boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",
            }}>
                {/* Header Section */}
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '20px',
                    paddingBottom: '16px',
                    borderBottom: '1px solid #f3f4f6'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <Box sx={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '6px',
                            backgroundColor: '#3b82f6',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FontAwesomeIcon icon={faTableList} style={{ color: 'white', fontSize: '16px' }} />
                        </Box>
                        <Typography variant="h4" sx={{
                            fontWeight: 600,
                            color: '#1f2937',
                            fontSize: { xs: '1.25rem', md: '1.5rem' },
                            letterSpacing: '-0.025em'
                        }}>
                            Gestion des Clients
                        </Typography>
                    </Box>

                    <Typography variant="body2" sx={{
                        color: '#6b7280',
                        fontSize: '14px',
                        fontWeight: 500,
                        backgroundColor: '#f9fafb',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        border: '1px solid #e5e7eb'
                    }}>
                        {Clients.length} client{Clients.length !== 1 ? 's' : ''}
                    </Typography>
                </Box>

                {/* Action Buttons Section */}
                <Box sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '20px',
                    marginTop: '30px',
                    alignItems: 'center',
                    justifyContent: { xs: 'center', md: 'space-between' }
                }}>
                    {/* Primary Actions */}
                    <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                        {isAllowedAjouterClient == 1 && (
                            <ButtonAttribute
                                Label="Ajouter"
                                action={handleOpen}
                                Bgcolor="#3b82f6"
                                color="white"
                                bgColorHover="#2563eb"
                                type="button"
                                height="45px"
                                width="150px"
                                startIcon={<FontAwesomeIcon color="white" icon={faPlus} style={{ fontSize: '14px' }} />}
                                hidden={true}

                            />
                        )}
                        {isAllowedModifierClient == 1 && (
                            <ButtonAttribute
                                Label="Modifier"
                                action={handleOpenModifier}
                                Bgcolor="#f59e0b"
                                color="white"
                                bgColorHover="#d97706"
                                type="button"
                                height="45px"
                                width="150px"
                                startIcon={<FontAwesomeIcon color="white" icon={faPen} style={{ fontSize: '14px' }} />}
                                hidden={true}

                            />
                        )}
                        {isAllowedSupprimerClient == 1 && (
                            <ButtonAttribute
                                Label="Supprimer"
                                action={handleOpenDeleteClient}
                                Bgcolor="#ef4444"
                                color="white"
                                bgColorHover="#dc2626"
                                type="button"
                                height="45px"
                                width="150px"
                                startIcon={<FontAwesomeIcon color="white" icon={faTrash} style={{ fontSize: '14px' }} />}
                                hidden={true}

                            />
                        )}
                        {isAllowedAjouterInterlocuteur == 1 && (
                            <ButtonAttribute
                                Label="Interlocuteurs"
                                action={HandleOpenShowInterlocuteurs}
                                Bgcolor="#06b6d4"
                                color="white"
                                bgColorHover="#0891b2"
                                type="button"
                                height="45px"
                                width="150px"
                                startIcon={<FontAwesomeIcon color="white" icon={faTableList} style={{ fontSize: '14px' }} />}
                                hidden={true}

                            />
                        )}
                    </Box>

                    {/* Secondary Actions */}
                    <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                        {isAllowedExporterClient == 1 && (
                            <ButtonAttribute
                                Label="Exporter"
                                action={handleOpenExtrationClient}
                                Bgcolor="#8b5cf6"
                                color="white"
                                bgColorHover="#7c3aed"
                                type="button"
                                height="45px"
                                width="150px"
                                startIcon={<FontAwesomeIcon color="white" icon={faFileExport} style={{ fontSize: '14px' }} />}
                                hidden={true}

                            />
                        )}
                        {isAllowedImporterClient == 1 && (
                            <ButtonAttribute
                                Label="Importer"
                                action={handleOpenImportationClient}
                                Bgcolor="#10b981"
                                color="white"
                                bgColorHover="#059669"
                                type="button"
                                height="45px"
                                width="150px"
                                startIcon={<FontAwesomeIcon color="white" icon={faFileImport} style={{ fontSize: '14px' }} />}
                                hidden={true}

                            />
                        )}
                    </Box>
                </Box>
            </Box>
        );
    };


    const columns = [
        {
            accessorKey: 'ID_Client',
            header: 'ID Client',
            size: 60,

        },
        {
            accessorKey: 'Nom',
            header: 'Nom',
            size: 200,
        },
        {
            accessorKey: 'Adresse',
            header: 'Adresse',
            size: 200,
        },
        {
            accessorKey: 'Contact',
            header: 'Contact',
            size: 200,
        },
        {
            accessorKey: 'Email',
            header: 'Email',
            size: 200,
        },
        {
            accessorKey: 'Type_Client',
            header: 'Type Client',
            size: 200,
            cell: ({ cell }) => (cell.getValue() == 1 ? 'Type_Client' : 'Indisponible'),
        },
        {
            accessorKey: 'Raison_sociale',
            header: 'Raison Sociale',
            size: 200,
        },
        {
            accessorKey: 'Forme_juridique',
            header: 'Forme Juridique',
            size: 200,
        },
        {
            accessorKey: 'Code_client',
            header: 'Code Client',
            size: 200,
        },
        {
            accessorKey: 'Sites',
            header: 'Sites',
            size: 200,
        },
        {
            accessorKey: 'IF',
            header: 'Identifiant Fiscal (IF)',
            size: 200,
        },
        {
            accessorKey: 'ICE',
            header: 'ICE',
            size: 200,
        },
        {
            accessorKey: 'taux_de_TVA',
            header: 'Taux de TVA',
            size: 200,
        },
        {
            accessorKey: 'taux_de_TVA_1',
            header: 'Taux de TVA 1',
            size: 200,
        },
        {
            accessorKey: 'Mode_de_reglement',
            header: 'Mode de Règlement',
            size: 200,
        },
        {
            accessorKey: 'Echéance_de_reglement',
            header: 'Échéance de Règlement',
            size: 200,
        },
        {
            accessorKey: 'Activité',
            header: 'Activité',
            size: 200,
        },
    ];





    // Function to get the 'allowed' value for a specific action
    const getPermission = (permissions, section, actionName) => {
        const sectionPermissions = permissions.find((perm) => perm.name === section);
        if (!sectionPermissions) return 0;

        const action = sectionPermissions.actions.find((act) => act.name === actionName);
        return action.allowed;
    };

    // Function to fetch Clients
    const fetchClients = async (token) => {

        try {
            const response = await axios.get(`${API}/clients`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setClients(response.data.data);
        } catch (error) {
            console.error('Error fetching Clients:', error);
            setErrors({ error: true, message: 'Failed to fetch Clients' });
        }

    };


    {/* begin modal ajouter Client  */ }

    const handleAjouterClient = () => {
        const storedAuthState = sessionStorage.getItem('authLocalstorage');
        const parsedAuthState = JSON.parse(storedAuthState);

        const requiredFields = [
            { key: 'Nom', label: 'Nom' },
            { key: 'Email', label: 'Email' },
            { key: 'Contact', label: 'Contact' },
            { key: 'Type_Client', label: 'Type de client' },
            { key: 'Code_client', label: 'Code client' },
        ];

        const missingFields = requiredFields
            .filter(({ key }) => !newClient[key] || newClient[key].toString().trim() === '')
            .map(({ label }) => label); // Ne garder que les labels manquants

        if (missingFields.length > 0) {
            console.warn("Champs manquants :", missingFields);
            setErrors({
                error: true,
                message: "Les champs suivants sont obligatoires : " + missingFields.join(", "),
            });
            return;
        }



        axios
            .post(`${API}/clients`, newClient, {
                headers: { Authorization: `Bearer ${parsedAuthState.token}` },
            })
            .then((response) => {
                handleClose();
                setAlertOpen(true);
                fetchClients(parsedAuthState.token);
                setNewClient({
                    Nom: '',
                    Adresse: '',
                    Email: '',
                    Contact: '',
                    Type_Client: '',
                    Raison_sociale: '',
                    Forme_juridique: '',
                    Code_client: '',
                    Sites: '',
                    IF: '',
                    ICE: '',
                    taux_de_TVA: '',
                    Mode_de_reglement: '',
                    Echéance_de_reglement: '', // ✅ Correction ici
                    Activité: '',
                });
                logOperation({
                    operation_type: "CREATE",
                    entity_type: "Client",
                    entity_id: parsedAuthState.user.id,
                    description: "Création des informations du client",
                });
            })
            .catch((error) => {
                console.error('Erreur lors de l’ajout du client:', error);
                setErrors({
                    error: true,
                    message: error?.response?.data?.message || "Erreur inconnue",
                });
            });
    };
    const isAllowedAjouterClient = getPermission(Permissions, 'Clients', 'ajouter Client');
    const isAllowedModifierClient = getPermission(Permissions, 'Clients', 'modifier Client');
    const isAllowedSupprimerClient = getPermission(Permissions, 'Clients', 'supprimer Client');
    const isAllowedExporterClient = getPermission(Permissions, 'Clients', 'exporter Client');
    const isAllowedImporterClient = getPermission(Permissions, 'Clients', 'importer Client');
    const isAllowedAjouterInterlocuteur = getPermission(Permissions, 'Interlocuteurs', 'ajouter Interlocuteur');

    return (
        <ThemeProvider theme={theme}>
            {role === 'user' || role === 'admin' || role === 'super-admin' || role === 'user-facture' ? (
                <Box
                    sx={{
                        flexGrow: 1,
                        backgroundColor: '#f8fafc',
                        padding: { xs: '16px', md: '20px' },
                        minHeight: '116vh',
                        transition: 'all 0.3s ease-in-out',
                    }}
                >
                    <MenuButton />
                    <Box sx={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        border: '1px solid #e5e7eb',
                        overflow: 'hidden'
                    }}>
                        <DataGridTable data={Clients} columns={columns} />
                    </Box>
                </Box>
            ) : null}


            {/* begin model ajouter Client  */}
            <BasicModal
                widthSpecial={'40%'}
                open={openAjouterClient}
                onClose={handleClose}
                ChildrenContent={
                    <Box  >
                        <Typography variant='h4' sx={{
                            fontSize: { lg: '40px', md: '30px', sm: '30px', xs: '20px' },
                            mb: 2,
                            fontFamily: 'Montserrat , sans-serif',
                            color: '#1D3E62',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            padding: '20px'
                        }}>
                            Nouveau Client
                        </Typography>
                        <Grid container spacing={1} sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: '12px',
                            color: '#1D3E62',
                            gap: '1.5px',
                            height: '480px',
                            overflowY: 'scroll'
                        }} >


                            <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                                <TextInputMui
                                    required={true}
                                    label="Nom"
                                    type="text"
                                    value={newClient.Nom}
                                    setValue={(e) => setNewClient({ ...newClient, Nom: e })}
                                // User Icon for Email
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                <TextInputMui
                                    required={true}
                                    label="Code Client"
                                    type="text"
                                    value={newClient.Code_client}
                                    setValue={(e) => setNewClient({ ...newClient, Code_client: e })}
                                // User Icon for Email
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                                <TextInputMui

                                    label="Adresse"
                                    type="text"
                                    value={newClient.Adresse}
                                    setValue={(e) => setNewClient({ ...newClient, Adresse: e })}
                                // User Icon for Email
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5} >
                                <TextInputMui
                                    required={true}
                                    label="Email"
                                    type="email"
                                    value={newClient.Email}
                                    setValue={(e) => setNewClient({ ...newClient, Email: e })}
                                // User Icon for Email
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                <TextInputMui
                                    required={true}
                                    label="Contact"
                                    type="tel"
                                    value={newClient.Contact}
                                    setValue={(e) => setNewClient({ ...newClient, Contact: e })}
                                // User Icon for Email
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                <AutocompleteComboBox
                                    required={true}
                                    widthSpecific={'100%'}
                                    Label={"Type Client"}
                                    list={typeClients}
                                    keyField={'label'}
                                    valueField={'value'}
                                    value={newClient.Type_Client}
                                    onChange={(e) => setNewClient({ ...newClient, Type_Client: e })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                <TextInputMui
                                    label="Raison Sociale"
                                    type="text"
                                    value={newClient.Raison_sociale}
                                    setValue={(e) => setNewClient({ ...newClient, Raison_sociale: e })}
                                // User Icon for Email
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                <TextInputMui
                                    label="Forme Juridique"
                                    type="text"
                                    value={newClient.Forme_juridique}
                                    setValue={(e) => setNewClient({ ...newClient, Forme_juridique: e })}
                                // User Icon for Email
                                />
                            </Grid>


                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                <TextInputMui
                                    label="Les sites"
                                    type="text"
                                    value={newClient.Sites}
                                    setValue={(e) => setNewClient({ ...newClient, Sites: e })}
                                // User Icon for Email
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                <TextInputMui

                                    label="Identifiant fiscale"
                                    type="text"
                                    value={newClient.IF}
                                    setValue={(e) => setNewClient({ ...newClient, IF: e })}
                                // User Icon for Email
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                <TextInputMui

                                    label="ICE"
                                    type="text"
                                    value={newClient.ICE}
                                    setValue={(e) => setNewClient({ ...newClient, ICE: e })}
                                // User Icon for Email
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                <TextInputMui
                                    label="Taux de TVA"
                                    type="text"
                                    value={newClient.taux_de_TVA}
                                    setValue={(e) => setNewClient({ ...newClient, taux_de_TVA: e })}
                                // User Icon for Email
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                <TextInputMui
                                    label="Taux de TVA 1"
                                    type="text"
                                    value={newClient.taux_de_TVA_1}
                                    setValue={(e) => setNewClient({ ...newClient, taux_de_TVA_1: e })}
                                // User Icon for Email
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                <AutocompleteComboBox
                                    widthSpecific={'100%'}
                                    Label={"Mode de reglement"}
                                    value={newClient.Mode_de_reglement}
                                    onChange={(e) => setNewClient({ ...newClient, Mode_de_reglement: e })}
                                    list={[
                                        { value: 'Espèces ', label: 'Espèces' },
                                        { value: 'Virement Bancaire', label: 'Virement Bancaire' },
                                        { value: 'Chèque', label: 'Chèque' },
                                        { value: 'Carte Bancaire', label: 'Carte Bancaire' },
                                        { value: 'Prélèvement Automatique', label: 'Prélèvement Automatique' },
                                    ]}
                                    valueField={'label'}
                                    keyField={'label'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>

                                <TextInputMui
                                    label="Echeance de reglement"
                                    type="number"
                                    value={newClient.Echéance_de_reglement}
                                    setValue={(e) => setNewClient({ ...newClient, Echéance_de_reglement: e })}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                <TextInputMui
                                    label="Activite"
                                    type="text"
                                    value={newClient.Activité}
                                    setValue={(e) => setNewClient({ ...newClient, Activité: e })}
                                />
                            </Grid>
                            <Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                </Grid>
                            </Grid>

                            <Grid xs={12} sm={12} md={12} lg={12} xl={12} sx={{
                                display: 'flex', justifyContent: 'center', alignItems: 'center',
                                mt: '20px'
                            }} >
                                <Box sx={{
                                    width: { xs: '150px', sm: '200px', md: '300px', lg: '400px', xl: '500px' },
                                    display: 'flex', justifyContent: 'center', alignItems: 'center'
                                }}>

                                </Box>
                            </Grid>

                        </Grid>
                        {errors.error === true ? (
                            <Typography variant='subtitle1' component="p" sx={{
                                color: 'red',
                                textAlign: 'center',
                                mb: '20px'

                            }}>  {errors.message} </Typography>
                        ) : null}
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <ButtonAttribute
                                type="submit"
                                Label="Ajouter"
                                color={'white'}
                                Bgcolor='#28A745'
                                height={'60px'}
                                width={'70%'}
                                action={() => {
                                    handleAjouterClient();
                                }}
                            />
                        </Box>
                    </Box>
                }
            />
            {/* end  model ajouter Client */}

            {/* begin model modifier Client and multiple Clients */}
            <BasicModal
                widthSpecial={'40%'}
                open={openModifierClient}
                onClose={handleCloseModifier}
                ChildrenContent={
                    rowsSelected.length === 1 ? <><Box>
                        <Typography variant='h4' sx={{
                            fontSize: { lg: '40px', md: '30px', sm: '30px', xs: '20px' },
                            mb: 2,
                            fontFamily: 'Montserrat , sans-serif',
                            color: '#1D3E62',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            padding: '20px'
                        }}>
                            Modifier Client ID :  {rowsSelected[0].ID_Client} </Typography>

                        <Box sx={{ display: 'grid', justifyContent: 'center' }} >
                            <Grid container spacing={1} sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: '12px',
                                color: '#1D3E62',
                                gap: '1.5px',
                                height: '480px',
                                overflowY: 'scroll'
                            }} >




                                <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                                    <TextInputMui
                                        label="Nom"
                                        type="text"
                                        value={modifierClient.Nom}
                                        setValue={(newValue) =>
                                            setModifierClient((prevState) => ({
                                                ...prevState,
                                                Nom: newValue,
                                            }))}
                                    // User Icon for Email
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                                    <TextInputMui
                                        label="Adresse"
                                        type="text"
                                        value={modifierClient.Adresse} // Use modifierClient
                                        setValue={(newValue) =>
                                            setModifierClient((prevState) => ({
                                                ...prevState,
                                                Adresse: newValue,
                                            }))
                                        }
                                    />

                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                                    <TextInputMui
                                        label="Email"
                                        type="text"
                                        value={modifierClient.Email}
                                        setValue={(newValue) =>
                                            setModifierClient((prevState) => ({
                                                ...prevState,
                                                Email: newValue,
                                            }))}
                                    // User Icon for Email
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                                    <TextInputMui
                                        label="Contact"
                                        type="text"
                                        value={modifierClient.Contact}
                                        setValue={(newValue) =>
                                            setModifierClient((prevState) => ({
                                                ...prevState,
                                                Contact: newValue,
                                            }))}
                                    // User Icon for Email
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
                                    <AutocompleteComboBox
                                        widthSpecific={'100%'}
                                        Label={"Type Client"}
                                        list={typeClients}
                                        keyField={"label"}
                                        valueField={"value"}
                                        value={modifierClient.Type_Client}
                                        onChange={(e) => setModifierClient({ ...modifierClient, Type_Client: e })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                    <TextInputMui
                                        label="Raison Sociale"
                                        type="text"
                                        value={modifierClient.Raison_sociale}
                                        setValue={(e) => setModifierClient({ ...modifierClient, Raison_sociale: e })}
                                    // User Icon for Email
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                    <TextInputMui
                                        label="Forme Juridique"
                                        type="text"
                                        value={modifierClient.Forme_juridique}
                                        setValue={(e) => setModifierClient({ ...modifierClient, Forme_juridique: e })}
                                    // User Icon for Email
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                    <TextInputMui
                                        label="Code Client"
                                        type="text"
                                        value={modifierClient.Code_client}
                                        setValue={(e) => setModifierClient({ ...modifierClient, Code_client: e })}
                                    // User Icon for Email
                                    />
                                </Grid>


                                <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                    <TextInputMui
                                        label="Les sites"
                                        type="text"
                                        value={modifierClient.Sites}
                                        setValue={(e) => setModifierClient({ ...modifierClient, Sites: e })}
                                    // User Icon for Email
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                    <TextInputMui
                                        label="Identifiant fiscale"
                                        type="text"
                                        value={modifierClient.IF}
                                        setValue={(e) => setModifierClient({ ...modifierClient, IF: e })}
                                    // User Icon for Email
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                    <TextInputMui
                                        label="ICE"
                                        type="text"
                                        value={modifierClient.ICE}
                                        setValue={(e) => setModifierClient({ ...modifierClient, ICE: e })}
                                    // User Icon for Email
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                    <TextInputMui
                                        label="Taux de TVA"
                                        type="text"
                                        value={modifierClient.taux_de_TVA}
                                        setValue={(e) => setModifierClient({ ...modifierClient, taux_de_TVA: e })}
                                    // User Icon for Email
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                    <TextInputMui
                                        label="Taux de TVA"
                                        type="text"
                                        value={modifierClient.taux_de_TVA_1}
                                        setValue={(e) => setModifierClient({ ...modifierClient, taux_de_TVA_1: e })}
                                    // User Icon for Email
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                    <AutocompleteComboBox
                                        widthSpecific={'100%'}
                                        Label={"Mode de reglement"}
                                        value={modifierClient.Mode_de_reglement}
                                        onChange={(e) => setModifierClient({ ...modifierClient, Mode_de_reglement: e })}
                                        list={[
                                            { value: 'Espèces ', label: 'Espèces' },
                                            { value: 'Virement Bancaire', label: 'Virement Bancaire' },
                                            { value: 'Chèque', label: 'Chèque' },
                                            { value: 'Carte Bancaire', label: 'Carte Bancaire' },
                                            { value: 'Prélèvement Automatique', label: 'Prélèvement Automatique' },
                                        ]}
                                        valueField={'label'}
                                        keyField={'label'}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>

                                    <TextInputMui
                                        label="Echeance de reglement"
                                        type="number"
                                        value={modifierClient.Echéance_de_reglement}
                                        setValue={(e) => setModifierClient({ ...modifierClient, Echéance_de_reglement: e })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={10} lg={5} xl={5}>
                                    <TextInputMui
                                        label="Activite"
                                        type="text"
                                        value={modifierClient.Activité}
                                        setValue={(e) => setModifierClient({ ...modifierClient, Activité: e })}
                                    />
                                </Grid>
                                <Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    </Grid>
                                </Grid>



                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}
                                    sx={{ display: 'flex', justifyContent: 'center' }} >

                                </Grid>

                            </Grid>

                            {errors.error === true ? (
                                <Typography variant='subtitle1' component="p" sx={{
                                    color: 'red',
                                    textAlign: 'center',

                                }}>  {errors.message} </Typography>
                            ) : null}

                            <Box sx={{

                                display: 'flex', justifyContent: 'center', alignItems: 'center'
                            }}>
                                <ButtonAttribute
                                    type="submit"
                                    Label="Modifier Client"
                                    color={'white'}
                                    Bgcolor='#28A745'
                                    height={'60px'}
                                    width={'50%'}
                                    action={handleOpenModifierOneClient}
                                />
                            </Box>
                        </Box>

                    </Box></> : <Typography variant='h4' sx={{
                        fontSize: { lg: '20px', md: '20px', sm: '20px', xs: '20px' },
                        mb: 2,
                        fontFamily: 'Montserrat , sans-serif',
                        color: '#1D3E62',
                        textAlign: 'center',
                        fontWeight: '600',
                        padding: '20px'
                    }}>
                        L'opération demandée est inexistante ou invalide.
                        Pour garantir la sécurité des données, les modifications multiples ne sont pas autorisées. Veuillez contacter l'administrateur pour plus d'assistance </Typography>}
            />
            {/* end  model modifier Client and multiple Clients */}

            {/* Begin model Delete Client  and multiple Clients */}
            <BasicModal
                open={openDeleteClient}
                onClose={handleCloseDeleteClient}
                ChildrenContent={
                    rowsSelected.length === 1 ? <><Box>
                        <Typography variant='h4' sx={{
                            fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },

                            fontFamily: 'Montserrat , sans-serif',
                            color: '#1D3E62',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            padding: '10px'
                        }}>
                            Suppression de la Client ID : {rowsSelected[0].ID_Client} </Typography>

                        <Typography variant='h6' sx={{
                            fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
                            mb: 1,
                            fontFamily: 'Montserrat , sans-serif',
                            color: '#1D3E62',
                            textAlign: 'center',

                            padding: '20px'
                        }} >Voulez-vous vraiment supprimer cette Client ?</Typography>
                        <Box
                            sx={{
                                display: { xs: 'grid', sm: 'grid', md: 'grid', lg: 'flex', xl: 'flex' },
                                justifyContent: 'space-evenly', alignItems: 'center', gap: '20px'
                            }} >

                            <ButtonAttribute
                                type="submit"
                                Label="Annuler"
                                color={'white'}
                                Bgcolor='gray'
                                height={'50px'}
                                width={'100%'}
                                action={handleCloseDeleteClient}
                            />
                            <ButtonAttribute
                                type="submit"
                                Label="Supprimer"
                                color={'white'}
                                Bgcolor='#DC3545'
                                height={'50px'}
                                width={'100%'}
                                action={handleOpenConfirmationPassword}
                            />

                        </Box>


                    </Box></> :
                        <><Box>
                            <Typography variant='h4' sx={{
                                fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },
                                fontFamily: 'Montserrat , sans-serif',
                                color: '#1D3E62',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                padding: '10px'
                            }}>
                                Suppression des Clients sélectionnées  </Typography>

                            <Typography variant='h6' sx={{
                                fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
                                mb: 1,
                                fontFamily: 'Montserrat , sans-serif',
                                color: '#1D3E62',
                                textAlign: 'center',
                                padding: '20px'
                            }} >Voulez-vous vraiment supprimer toutes les Clients sélectionnées ?</Typography>

                            {rowsSelected.length > 1 ? (
                                <Box sx={{ justifyContent: "center", display: 'flex', gap: '5px', width: '100%', overflowX: 'auto', marginBottom: '20px' }}>
                                    {rowsSelected.map((row, index) => (
                                        <Box
                                            key={index} // Use a unique key. Ideally, use a unique identifier from `row` if available.
                                            sx={{
                                                display: 'grid',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                marginBottom: '20px',

                                                padding: '10px',
                                                width: '50px',
                                                height: '40px',
                                                borderRadius: '10%',
                                                backgroundColor: '#DC3545',
                                            }}
                                        >
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    color: '#fff',
                                                    fontSize: 14,
                                                    textAlign: 'center',
                                                    fontFamily: 'Montserrat, sans-serif',
                                                }}
                                            >
                                                {row.ID_Client || 'N/A'} {/* Safeguard in case `id` is undefined */}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            ) : null}




                            <Box
                                sx={{
                                    display: { xs: 'grid', sm: 'grid', md: 'grid', lg: 'flex', xl: 'flex' },
                                    justifyContent: 'space-evenly', alignItems: 'center', gap: '20px'
                                }} >

                                <ButtonAttribute
                                    type="submit"
                                    Label="Annuler"
                                    color={'white'}
                                    Bgcolor='gray'
                                    height={'50px'}
                                    width={'100%'}
                                    action={handleCloseDeleteClient}
                                />
                                <ButtonAttribute
                                    type="submit"
                                    Label="Supprimer toutes"
                                    color={'white'}
                                    Bgcolor='#DC3545'
                                    height={'50px'}
                                    width={'100%'}
                                    action={handleOpenConfirmationPassword}
                                />

                            </Box>


                        </Box></>}
            />
            {/* end model Delete Client  and multiple Clients */}

            {/* begin model export Client */}
            <BasicModal
                open={openExtrationClient}
                onClose={handleCloseExtrationClient}
                ChildrenContent={<><Box>
                    <Typography variant='h4' sx={{
                        fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },

                        fontFamily: 'Montserrat , sans-serif',
                        color: '#1D3E62',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        padding: '10px'
                    }}>
                        Extraction des données des clients </Typography>

                    <Typography variant='h6' sx={{
                        fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
                        mb: 1,
                        fontFamily: 'Montserrat , sans-serif',
                        color: '#1D3E62',
                        textAlign: 'center',
                        padding: '20px'
                    }} >Vous disposez de deux types d'extraction des transactions. Si vous souhaitez extraire l'intégralité des données ou uniquement certains éléments, merci de les préciser dans le tableau.</Typography>

                    <Box
                        sx={{
                            display: 'grid',
                            alignItems: 'center', gap: '2px'
                        }} >

                        <ButtonAttribute
                            type="button"
                            Label="Extraire toutes les données ( XLSX )"
                            Bgcolor='#17A2B8'
                            color='white'
                            bgColorHover={'#117A8B'}
                            height={'70px'}
                            width={'100%'}
                            endIcon={<FontAwesomeIcon icon={faDownload} color='white' />}
                            action={handleExtrationAllClient}
                        />
                        <ButtonAttribute
                            type="submit"
                            Label="Extraire les données sélectionnées ( XLSX )"
                            Bgcolor='#17A2B8'
                            color='white'
                            bgColorHover={'#117A8B'}
                            height={'70px'}
                            width={'100%'}
                            action={handleExtrationSelectionsClients}
                            endIcon={<FontAwesomeIcon icon={faDownload} color='white' />}
                        />

                    </Box>


                </Box></>}
            />
            {/* end  model export Client */}

            {/* begin model importation Client */}
            <BasicModal
                open={openImportationClient}
                onClose={handleCloseImportationClient}
                ChildrenContent={<><Box>
                    <Typography variant='h4' sx={{
                        fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },

                        fontFamily: 'Montserrat , sans-serif',
                        color: '#1D3E62',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        padding: '10px'
                    }}>
                        Importation des données des clients </Typography>

                    <Typography variant='h6' sx={{
                        fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
                        mb: 1,
                        fontFamily: 'Montserrat , sans-serif',
                        color: '#1D3E62',
                        textAlign: 'center',
                        padding: '20px'
                    }} > Veuillez utiliser ce formulaire pour importer les Clients depuis un fichier Excel </Typography>
                    <ButtonAttribute
                        type="button"
                        Label="Télécharger le formulaire Excel"
                        Bgcolor='#17A2B8'
                        color='white'
                        bgColorHover={'#117A8B'}
                        height={'80px'}
                        width={'100%'}
                        endIcon={<FontAwesomeIcon icon={faDownload} color='white' />}
                        action={handleDownload}
                    />
                    <Divider />
                    <Box
                        sx={{
                            display: 'grid',
                            justifyContent: 'space-evenly', alignItems: 'center',

                        }} >
                        <Typography variant='h6' sx={{
                            fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
                            mb: 1,
                            fontFamily: 'Montserrat , sans-serif',
                            color: '#1D3E62',
                            textAlign: 'center',
                            padding: '20px'
                        }} > Cliquez sur le bouton ci-dessous pour sélectionner et importer votre fichier.</Typography>
                        <ButtonAttribute
                            type="button"
                            Label="Importer toutes les données de Clients"
                            Bgcolor='#17A2B8'
                            color='white'
                            bgColorHover={'#117A8B'}
                            height={'70px'}
                            width={'100%'}
                            endIcon={<FontAwesomeIcon icon={faCloudArrowUp} color='white' />}
                            action={triggerFileInput}
                        />
                        <input
                            id="file-upload"
                            type="file"
                            accept=".xlsx, .xls , .csv"
                            style={{ display: 'none' }}
                            onChange={handleFileImport}
                        />
                        <CustomizedProgressBars
                            value={isLoading}
                            color={
                                importStatus === "success"
                                    ? "success"
                                    : importStatus === "error"
                                        ? "error"
                                        : importStatus === "processing"
                                            ? "primary"
                                            : "gray"
                            }
                        />
                    </Box>


                </Box></>}
            />

            {/* end model importation Client */}

            {/* begin model confirmation password delete Clients */}

            <BasicModal
                open={openConfirmationPassword}
                onClose={handleCloseConfirmationPassword}
                ChildrenContent={<><Box>
                    <Typography variant='h4' sx={{
                        fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },
                        fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center',
                        fontWeight: 'bold', padding: '20px', marginBottom: '20px'
                    }}>
                        Veuillez saisir votre mot de passe pour confirmer la suppression de la Client
                    </Typography>
                    <Box sx={{ display: 'grid', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
                        <TextInputMui
                            type="password"
                            label="Mot de passe"
                            name="password"
                            value={ConfrimedPassword.password}
                            setValue={(e) => setConfirmedPassword({ ...ConfrimedPassword, password: e })}
                            required
                        />
                        <ButtonAttribute
                            type="submit"
                            Label="Confirmer la suppression"
                            Bgcolor='#17A2B8'
                            color='white'
                            bgColorHover={'#117A8B'}
                            height={'50px'}
                            width={'100%'}
                            endIcon={<FontAwesomeIcon icon={faCheck} color='white' />}
                            action={handleVerificationPassword}
                        />

                    </Box>
                </Box></>} />

            {/* end model confirmation password delete Clients */}


            {/* begin bASICMODL for afficher  Interlocuteurs */}
            <BasicModal
                open={openShowInterlocuteurs}
                onClose={HandleCloseShowInterlocuteurs}
                ChildrenContent={rowsSelected.length === 1 ?
                    <><Box>
                        <Typography
                            variant="h4"
                            sx={{
                                fontSize: { lg: '30px', md: '25px', sm: '22px', xs: '20px' },
                                fontWeight: 'bold',
                                color: '#1D3E62',
                                textAlign: 'center',
                                marginBottom: '20px',
                                fontFamily: 'Montserrat, sans-serif',
                            }}
                        >
                            Interlocuteurs de {modifierClient?.Nom}
                        </Typography>

                        {/* TABLE LIST */}
                        <Box sx={{ maxHeight: '300px', overflowY: 'auto', mb: 3 }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead style={{ backgroundColor: '#f0f0f0' }}>
                                    <tr>
                                        <th style={thStyle}>Nom</th>
                                        <th style={thStyle}>Fonction</th>
                                        <th style={thStyle}>Email</th>
                                        <th style={thStyle}>Contact</th>
                                        <th style={thStyle}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(interlocuteurs || []).map((i, index) => (
                                        <tr key={index}>
                                            <td style={tdStyle}>{i.Nom}</td>
                                            <td style={tdStyle}>{i.Fonction}</td>
                                            <td style={tdStyle}>{i.Email}</td>
                                            <td style={tdStyle}>{i.Contact}</td>
                                            <td style={tdStyle}>
                                                <ButtonAttribute
                                                    Label="Supprimer"
                                                    Bgcolor="#DC3545"
                                                    color="white"
                                                    height="35px"
                                                    width="100%"
                                                    action={() => handleDeleteInterlocuteur(i.id)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>

                            </table>
                        </Box>

                        {/* FORM */}
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="h6" sx={{ textAlign: "center", fontWeight: "bold", mb: 2, color: "#1D3E62" }}>
                                Ajouter un nouvel interlocuteur
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <TextInputMui
                                        label="Nom"
                                        type="text"
                                        value={newInterlocuteur.Nom}
                                        setValue={(e) => setNewInterlocuteur({ ...newInterlocuteur, Nom: e })}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextInputMui
                                        label="Fonction"
                                        type="text"
                                        value={newInterlocuteur.Fonction}
                                        setValue={(e) => setNewInterlocuteur({ ...newInterlocuteur, Fonction: e })}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextInputMui
                                        label="Email"
                                        type="email"
                                        value={newInterlocuteur.Email}
                                        setValue={(e) => setNewInterlocuteur({ ...newInterlocuteur, Email: e })}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextInputMui
                                        label="Contact"
                                        type="tel"
                                        value={newInterlocuteur.Contact}
                                        setValue={(e) => setNewInterlocuteur({ ...newInterlocuteur, Contact: e })}
                                    />
                                </Grid>
                            </Grid>
                        </Box>

                        {errorsInterlocuteur.errors == true && <p style={{ color: 'red', textAlign: 'center' }}>{errorsInterlocuteur.message}</p>}
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <ButtonAttribute
                                Label="Ajouter"
                                Bgcolor="#28A745"
                                color="white"
                                bgColorHover="#218838"
                                height="50px"
                                width="100%"
                                action={handleAddInterlocuteur}
                            />
                        </Box>
                    </Box></> : <Typography variant='h4' sx={{
                        fontSize: { lg: '20px', md: '20px', sm: '20px', xs: '20px' },
                        mb: 2,
                        fontFamily: 'Montserrat , sans-serif',
                        color: '#1D3E62',
                        textAlign: 'center',
                        fontWeight: '600',
                        padding: '20px'
                    }}>
                        Veuillez sélectionner un seul client pour afficher les interlocuteurs.
                        La sélection multiple n'est pas autorisée pour cette opération. Si vous avez besoin d'assistance, veuillez contacter l'administrateur. </Typography>
                } />
            {/* alert for ajouter */}
            <AlertBar
                open={alertOpen}
                onClose={handleAlertClose}
                textContent="La Client a été ajoutée avec succès."
                alertColor="success"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            />
            {/* alert for ajouter */}

            {/* alert for modifier */}
            <AlertBar
                open={alertOpenSelectedModifier}
                onClose={handleAlertCloseSelectedModifier}
                textContent="Veuillez choisir une ligne"
                alertColor="warning"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            />
            {/* not modifer line  row  */}
            <AlertBar
                open={alertOpenNotModiferRow}
                onClose={handleAlertCloseNotModiferRow}
                textContent={"Aucune des informations n'a été modifiée, donc je ne vais pas effectuer l'opération."}
                alertColor={"info"}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            />
            {/*  alert for modifier success */}
            <AlertBar
                open={alertOpenUpdatedClient}
                onClose={handleAlertCloseUpdatedClient}
                textContent="Client mise à jour avec succès" alertColor="success"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            />
            {/*  alert for modifier  */}

            {/* alert for delete Client one row  */}
            <AlertBar
                open={alertOpenDeletedClient}
                onClose={handleAlertCloseDeletedClient}
                textContent="Client supprimée avec succès " alertColor="success"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            />
            <AlertBar
                open={alertOpenPasswordNotValid}
                onClose={handleAlertClosePasswordNotValid}
                textContent="Mot de passe incorrect pour supprimer la Client" alertColor="error"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            />
            <AlertBar
                open={alertOpenMultiDeletedClient}
                onClose={handleAlertMultiCloseDeletedClient}
                textContent="Toutes les Clients ont été supprimées avec succès." alertColor="success"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            />
            {/* end alert for delete Client one row  */}

            {/* alert for extration Client   */}
            <AlertBar
                open={alertOpenNotSelectedLineExtration}
                onClose={handleAlertCloseNotSelectedLineExtration}
                textContent={"Veuillez préciser les lignes que vous souhaitez extraire pour télécharger le fichier au format .csv"}
                alertColor={"info"}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            />
            {/* alert for importation Client   */}
            <AlertBar
                open={alertOpenImport}
                onClose={handleCloseAlertImport}
                textContent="Importation effectuée avec succès ! Les données ont été ajoutées correctement"
                alertColor="success"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            />
            <AlertBar
                open={alertErrorImport}
                onClose={handleCloseErrorAlertImport}
                textContent="Importation non effectuée : le fichier contient des erreurs ou les valeurs sont incorrectes. Veuillez vérifier et réessayer."
                alertColor="error"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            />
            {/* end alert for importation Client   */}

            {/* begin alert confirmation password delete Clients */}
            <AlertBar
                open={alertOpenConfirmDeleteClient}
                onClose={handleCloseAlertConfirmDeleteClient}
                textContent="le mot de passe est incorrect !"
                alertColor="error"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            />
            {/* end alert confirmation password delete Clients */}

            {/*  alert for ajouter interlocuteur */}
            <AlertBar
                open={alertOpenAjouterInterlocuteur}
                onClose={handleCloseAlertInterlocuteur}
                textContent="Ajouté effectuée avec succès ! Le nouvel interlocuteur a été ajouté."
                alertColor="success"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            />

            <AlertBar
                open={alertOpenDeletedInterlocuteur}
                onClose={handleCloseAlertDeletedInterlocuteur}
                textContent="Interlocuteur supprimée avec succès !"
                alertColor="success"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            />

        </ThemeProvider>
    );
};



